<dx-resizable [width]="size.Width"
  [height]="size.Height"
  [minWidth]="100"
  [minHeight]="100"
  (onResize)="onResize($event)"
  class="ep-chart">
  <dx-chart id="chart"
    [dataSource]="values"
    [palette]="currentPalette"
    [title]="$safeNavigationMigration(chartConfiguration?.Header)">

    @for (serie of series; track serie) {
      <dxi-series [valueField]="serie.Name" [name]="serie.Name"></dxi-series>
    }

    <dxo-common-series-settings argumentField="GroupValue" type="spline">
    </dxo-common-series-settings>
    <dxo-legend verticalAlignment="bottom"
      horizontalAlignment="center">
    </dxo-legend>
    <dxo-size [width]="innerSize.Width" [height]="innerSize.Height"></dxo-size>
    <dxo-export [enabled]="true"></dxo-export>
    <dxo-tooltip [enabled]="true"></dxo-tooltip>
    <dxo-loading-indicator [show]="isLoading"></dxo-loading-indicator>
  </dx-chart>
</dx-resizable>
